var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"news"},[_c('h1',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.Ltype)+"\n  ")]),_c('div',{staticClass:"list",class:{ 'new-list': _vm.Ltype === '新闻报道' }},[_c('div',{staticClass:"item"},[_vm._v("暂无数据")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }